"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = expandMarginPadding;

var _js = require("@adeira/js");

var _StyleCollectorNode = _interopRequireDefault(require("../StyleCollectorNode"));

/**
 * 
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties#Margin_and_Padding_Properties
 */
function isLogicalProperty(propertyName) {
  return propertyName.endsWith('Block') || propertyName.endsWith('Inline');
}
/**
 * Margin -> Margin Top/Right/Bottom/Left
 * Margin Block -> Margin Block Start/End
 * Margin Inline -> Margin Inline Start/End
 *
 * Padding -> Padding Top/Right/Bottom/Left
 * Padding Block -> Padding Block Start/End
 * Padding Inline -> Padding Inline Start/End
 */


function expandMarginPadding(propertyName, propertyValue) {
  var hashSeed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  function getExpandedNodes(a, b, c, d) {
    if (isLogicalProperty(propertyName)) {
      return [new _StyleCollectorNode.default("".concat(propertyName, "Start"), a, hashSeed), new _StyleCollectorNode.default("".concat(propertyName, "End"), b, hashSeed)];
    }

    return [new _StyleCollectorNode.default("".concat(propertyName, "Top"), a, hashSeed), new _StyleCollectorNode.default("".concat(propertyName, "Right"), b, hashSeed), new _StyleCollectorNode.default("".concat(propertyName, "Bottom"), c, hashSeed), new _StyleCollectorNode.default("".concat(propertyName, "Left"), d, hashSeed)];
  }

  if (typeof propertyValue === 'string') {
    var chunks = propertyValue.split(/\s+/);

    if (chunks.length === 1) {
      return getExpandedNodes(chunks[0], chunks[0], chunks[0], chunks[0]);
    } else if (chunks.length === 2) {
      return getExpandedNodes(chunks[0], chunks[1], chunks[0], chunks[1]);
    } else if (chunks.length === 3) {
      !(isLogicalProperty(propertyName) === false) ? process.env.NODE_ENV !== "production" ? (0, _js.invariant)(false, 'Logical property "%s" cannot have more than 2 values (got 3: "%s").', propertyName, propertyValue) : (0, _js.invariant)(false) : void 0;
      return getExpandedNodes(chunks[0], chunks[1], chunks[2], chunks[1]);
    } else if (chunks.length === 4) {
      !(isLogicalProperty(propertyName) === false) ? process.env.NODE_ENV !== "production" ? (0, _js.invariant)(false, 'Logical property "%s" cannot have more than 2 values (got 4: "%s").', propertyName, propertyValue) : (0, _js.invariant)(false) : void 0;
      return getExpandedNodes(chunks[0], chunks[1], chunks[2], chunks[3]);
    }
  } else if (typeof propertyValue === 'number') {
    return getExpandedNodes(propertyValue, propertyValue, propertyValue, propertyValue);
  }

  return [new _StyleCollectorNode.default(propertyName, propertyValue, hashSeed)];
}